import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pos-parts-table-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "No Items Found")
], -1)
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "kit-description block" }
const _hoisted_5 = { class: "part-number blue-text block" }
const _hoisted_6 = { class: "part-manufactured-description block" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "required-text ml-2"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex p-0 m-0 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: _ctx.value,
      scrollable: !_ctx.isMobile,
      scrollHeight: _ctx.isMobile ? undefined : _ctx.scrollHeight,
      class: "p-datatable-sm",
      dataKey: "part_number",
      responsiveLayout: "stack",
      breakpoint: "768px",
      stripedRows: "",
      onRowClick: _ctx.onRowClick,
      loading: _ctx.isLoading,
      paginator: _ctx.showPaginator,
      rows: _ctx.showPaginator ? 10 : undefined,
      rowsPerPageOptions: _ctx.showPaginator ? [5, 10, 20, 50] : undefined,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      rowClass: _ctx.getRowClass
    }, {
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, { class: "product-image-column" }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "product-image",
                  src: slotProps.data.image,
                  alt: slotProps.data.desc
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "part_number",
          class: "flex-column align-items-baseline kit-description-wrapper"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(slotProps.data.kit), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(slotProps.data.desc || slotProps.data.wrap_desc
            ? slotProps.data.desc || slotProps.data.wrap_desc
            : "NO DESCRIPTION AVAILABLE"), 1),
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode("Part #" + _toDisplayString(slotProps.data.altcode1 || slotProps.data.part_number || slotProps.data.part_no) + " ", 1),
              (slotProps.data.code)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "| Code #: " + _toDisplayString(slotProps.data.code), 1))
                : _createCommentVNode("", true),
              (slotProps.data.required === 'Y')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (Required) "))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "justify-content-center tag-column",
          field: "onHand"
        }, {
          body: _withCtx(({ data }) => [
            (_ctx.getAvailableQuantity(data) !== undefined)
              ? (_openBlock(), _createBlock(_component_Tag, {
                  key: 0,
                  severity: _ctx.handleOnHandTagColor(_ctx.getAvailableQuantity(data)!),
                  value: _ctx.handleOnHandTagText(_ctx.getAvailableQuantity(data)!),
                  rounded: "",
                  class: "text-center on-hand-tag"
                }, null, 8, ["severity", "value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "blue-text font-bold code-price-wrapper",
          field: "price"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.price)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatPrice(slotProps.data.price)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "quantity",
          class: "quantity-wrapper",
          style: {"min-width":"140px"}
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = (event) => event.stopPropagation())
            }, [
              _createVNode(_component_InputNumber, {
                class: "quantity-input",
                modelValue: slotProps.data.quantity,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.quantity) = $event),
                inputId: "horizontal-buttons",
                min: 0,
                step: _ctx.calculateStep(slotProps.data),
                showButtons: "",
                buttonLayout: "horizontal",
                decrementButtonclass: "p-button-danger",
                incrementButtonclass: "p-button-success",
                incrementButtonIcon: "pi pi-plus",
                decrementButtonIcon: "pi pi-minus",
                onInput: ($event: any) => (_ctx.updatePrice($event, slotProps.data))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onInput"])
            ])
          ]),
          _: 1
        }),
        (_ctx.showAddToCartBtn)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              class: "cart-wrapper",
              style: {"min-width":"140px"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    class: "add-to-cart-btn pl-2 pr-2 xl:pl-3 xl:pr-3",
                    style: _normalizeStyle(_ctx.buttonColor(slotProps.data.quantity)),
                    label: "Add to Cart",
                    onClick: ($event: any) => (_ctx.addItem(slotProps.data))
                  }, null, 8, ["style", "onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "scrollable", "scrollHeight", "onRowClick", "loading", "paginator", "rows", "rowsPerPageOptions", "rowClass"])
  ]))
}